import gsap from 'gsap'
import Swiper from 'swiper'
import { Navigation, A11y, Scrollbar } from 'swiper/modules'

let config

export const initSwiper = () => {
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => {
		const type = slider.getAttribute('data-swiper')
		const nextEl = slider.parentElement.querySelector('.swiper-nav-next')
		const prevEl = slider.parentElement.querySelector('.swiper-nav-prev')
		const scrollbarEl = slider.parentElement.querySelector('.swiper-scrollbar')

		switch (type) {
			case 'reviews':
				config = {
					modules: [A11y, Navigation, Scrollbar],
					loop: false,
					speed: 750,
					spaceBetween: 24,
					slidesPerView: 1.1,
					navigation: {
						nextEl,
						prevEl
					},
					scrollbar: {
						el: scrollbarEl
					},
					breakpoints: {
						651: {
							spaceBetween: 36,
							slidesPerView: 2.1,
						},
						1025: {
							spaceBetween: 36,
							slidesPerView: 4.2,
						}
					}
				}
			break;
			case 'articles':
				config = {
					modules: [A11y, Navigation],
					loop: false,
					speed: 750,
					spaceBetween: 24,
					slidesPerView: 1.1,
					navigation: {
						nextEl,
						prevEl
					},
					breakpoints: {
						651: {
							spaceBetween: 36,
							slidesPerView: 2.1,
						},
						1024: {
							spaceBetween: 36,
							slidesPerView: 3,
						}
					}
				}
			break;
			case 'caseStudies':
				config = {
					modules: [A11y, Navigation, Scrollbar],
					loop: false,
					speed: 750,
					spaceBetween: 24,
					slidesPerView: 1.1,
					scrollbar: {
						el: scrollbarEl
					},
					navigation: {
						nextEl,
						prevEl
					},
					breakpoints: {
						651: {
							spaceBetween: 36,
							slidesPerView: 2.1,
						},
						1024: {
							spaceBetween: 36,
							slidesPerView: 1.6,
						}
					}
				}
			break;
			case 'benefits':
				config = {
					modules: [Scrollbar],
					loop: false,
					speed: 750,
					spaceBetween: 24,
					slidesPerView: 1.25,
					scrollbar: {
						el: scrollbarEl
					},
					breakpoints: {
						651: {
							spaceBetween: 36,
							slidesPerView: 2.1,
						}
					},
				}
			break;
			case 'process':
				config = {
					modules: [Scrollbar, Navigation],
					loop: false,
					speed: 750,
					spaceBetween: 24,
					slidesPerView: 1.1,
					scrollbar: {
						el: scrollbarEl
					},
					navigation: {
						nextEl,
						prevEl
					},
					breakpoints: {
						651: {
							spaceBetween: 36,
							slidesPerView: 2,
						},
						1025: {
							spaceBetween: 36,
							slidesPerView: 2.2,
						}
					},
					on: {
						slideChange: function (e) {
							if (e.activeIndex > 0 && window.innerWidth > 1024) {
								gsap.to('.process__content', { duration: 0.3, opacity: 0 })
							} else {
								gsap.to('.process__content', { duration: 0.3, delay: 0.15, opacity: 1 })
							}
						}
					}
				}
			break;
			case 'features':
				config = {
					loop: false,
					speed: 750,
					spaceBetween: 24,
					slidesPerView: 1.25,
					createElements: true,
					breakpoints: {
						651: {
							spaceBetween: 36,
							slidesPerView: 1.75,
						},
						1025: {
							enabled: false
						}
					},
				}
			break;
			default:
			break;
		}

		const swiper = new Swiper(slider, {...config })

	})
}

export default () => {}
